module.exports = __webpack_public_path__ + "static/img/14areaA_8.60c6624.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_8.png
// module id = 1012
// module chunks = 1